import React, { useState } from 'react';
import { Button } from 'antd';

import { ProfileCorporateInfoModel } from 'api/backofficeApiClient';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { getCorporateTASupervisorInformation } from 'redux/reducers/recruiterSlice';
import BaseSectionMessage from 'components/wrappers/BaseSectionMessage';
import BasePageCard from 'components/wrappers/BasePageCard';
import BaseAlert from 'components/wrappers/BaseAlert';
import SupervisorCard from 'features/account/AdditionalInfo/SupervisorInfo/SupervisorCard';
import EditSupervisorInfoModal from 'features/account/AdditionalInfo/SupervisorInfo/EditSupervisorInfoModal';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props = {
  corporateInfo?: ProfileCorporateInfoModel;
};

export default function SupervisorInfoSection(props: Props) {
  const { corporateInfo } = props;
  const dispatch = useAppDispatch();
  const [supervisorInfo, setSupervisorInfo] = useState(
    corporateInfo?.supervisors,
  );
  const [isModalVisible, setIsModalVisible] = useState(false);

  const loadSupervisorInfo = async () => {
    const result = await dispatch(
      getCorporateTASupervisorInformation(corporateInfo?.companyId),
    );

    if (getCorporateTASupervisorInformation.fulfilled.match(result)) {
      setSupervisorInfo(result.payload);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <>
      {isModalVisible && (
        <EditSupervisorInfoModal
          companyId={corporateInfo?.companyId}
          onClose={() => setIsModalVisible(false)}
          onEdit={loadSupervisorInfo}
          supervisorInfo={supervisorInfo}
        />
      )}

      <BasePageCard
        title="Supervisor information"
        className="stretch-card"
        icons={<span className="icon icon-supervisor"></span>}
        subTitle={
          <Button
            onClick={() => setIsModalVisible(true)}
            className="with-icon mobile-icon-only"
            size="large"
            icon={<span className="icon icon-edit" />}
          >
            Edit
          </Button>
        }
      >
        <div className="scroll-box">
          {!supervisorInfo?.length && (
            <div className="content-wrapper">
              <BaseSectionMessage
                type="info"
                title="Info"
                message={
                  <span>
                    Waiting for member to respond. Supervisor information will
                    be displayed after a member enters the data.
                  </span>
                }
              />
            </div>
          )}

          {!!supervisorInfo?.length && (
            <>
              {supervisorInfo.map((supervisor, index) => (
                <SupervisorCard key={index} supervisor={supervisor} />
              ))}
            </>
          )}
        </div>
      </BasePageCard>
    </>
  );
}
